import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Form, Field } from 'react-final-form';
import { TextField, Checkbox, Radio, Select } from 'final-form-material-ui';
import {
  Typography,
  Paper,
  Switch,
  Grid,
  Button,
  CssBaseline,
  RadioGroup,
  FormLabel,
  MenuItem,
  FormGroup,
  FormControl,
  FormControlLabel,
  Divider,
  CircularProgress,
} from '@material-ui/core';
import { getExpensesCategory, createExpensesCategory, putExpensesCategory } from '../../../business/actions/expense-categorisation'
import { validateFields } from '../../../utils'
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageHeading from '../../../components/ui/PageHeading';
const testData = { "text": "Booster" }

export default function Create(props) {
  const [busy, setBusy] = useState(false)
  const history = useHistory();
  const categorization_id = props.match.params?.categorization_id || null
  const [data, setData] = useState(process.env.NODE_ENV === "development" ? testData : {})
  useEffect(() => {
    if (categorization_id) getExpensesCategory(categorization_id).then(setData)
  }, [categorization_id])
  const validate = values => validateFields(values, ["text"])
  const onSubmit = (values) => {
    setBusy(true)
    if (categorization_id) {
      putExpensesCategory(categorization_id, values)
        .then(response => { toast('Expense Categorization updated.'); setTimeout(history.goBack, 1000) })
        .catch(error => toast(error.response.data?.message || `Expense Categorization is not updated. Unexpected error`))
        .finally(() => { setBusy(false) })
    }
    else {
      createExpensesCategory(values)
        .then(response => { toast('Expense Categorization created.'); setTimeout(history.goBack, 1000) })
        .catch(error => toast(error.response.data?.message || "Expense Categorization is not created. Unexpected error"))
        .finally(() => { setBusy(false) })
    }
    return true;
  }
  return (
    <div className={"form-wrapper"}>
      <Form
        onSubmit={onSubmit}
        initialValues={{ text: data?.text || "Marketing", }}
        validate={validate}
        render={({ handleSubmit, form, submitting, pristine, values }) => (
          <form onSubmit={handleSubmit} noValidate>
            <Paper>
              <PageHeading title={`${categorization_id ? 'Edit' : 'Create'} Expense Categorization`} />
              <Divider />
              <div style={{ padding: 16 }}>
                <Grid container alignItems="flex-start" spacing={2}>
                  <Grid item xs={12}>
                    <Field name="text" fullWidth required component={TextField} type="text" label="Expense Categorization" />
                  </Grid>
                  <Grid item style={{ marginTop: 16 }}>
                    <Button type="button" variant="contained" onClick={() => form.reset()} disabled={submitting || pristine}>
                      Reset
                    </Button>
                  </Grid>
                  <Grid item style={{ marginTop: 16 }}>
                    <Button variant="contained" color="primary" type="submit" disabled={submitting || pristine}>
                      {categorization_id ? 'Update' : 'Submit'}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Paper>
          </form>
        )}
      />
      {busy ? <div className='busy-progress-circular'><CircularProgress /></div> : null}
    </div>
  );
}